/**
 * Careers form (Gravity Forms): group the first five `.gfield` rows
 * into one wrapper and the remaining fields into another, for two-column layout.
 *
 * The `careers-form` class is expected on the `<form>` (GF “Form CSS Class”).
 * Field rows are the direct children `.gfield` of `.gform_fields` inside that form.
 */

const PRIMARY_CLASS = 'careers-form__fields careers-form__fields--primary';
const SECONDARY_CLASS = 'careers-form__fields careers-form__fields--secondary';

function wrapCareersFormColumns() {
  document.querySelectorAll('form.careers-form').forEach((form) => {
    const fieldsRoot = form.querySelector('.gform_fields');
    if (!fieldsRoot) {
      return;
    }

    if (fieldsRoot.querySelector(':scope > .careers-form__fields')) {
      return;
    }

    const fields = [...fieldsRoot.querySelectorAll(':scope > .gfield')];
    if (fields.length <= 5) {
      return;
    }

    const primary = document.createElement('div');
    primary.className = PRIMARY_CLASS;

    const secondary = document.createElement('div');
    secondary.className = SECONDARY_CLASS;

    fields.slice(0, 5).forEach((el) => primary.appendChild(el));
    fields.slice(5).forEach((el) => secondary.appendChild(el));

    fieldsRoot.appendChild(primary);
    fieldsRoot.appendChild(secondary);
  });
}

function initCareersFormLayout() {
  wrapCareersFormColumns();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCareersFormLayout);
} else {
  initCareersFormLayout();
}

if (window.jQuery) {
  jQuery(document).on('gform_post_render', initCareersFormLayout);
}
